import Property from 'components/PropertyPage/PropertyLayout';
import { wrapper } from 'pages/_app.page';
import { fetchPropertySuccess, setExclusive } from 'store/property/propertyActions';
import { fetchExclusiveOffer } from 'lib/clients/fetchExclusiveOffer';
import { fetchPropertyDetails } from 'lib/clients/fetchPropertyDetails';
import { setExclusiveOffer } from 'store/exclusiveOffer/exclusiveOfferActions';
import { sanitizeProperty } from 'lib/sanitize';
import isEqual from 'lodash/isEqual';
import queryString from 'query-string';
import authenticateUser from 'lib/user/authenticateUser';

const getPropertyId = (propertyId) => {
  const match = propertyId.match(/([0-9]*)/);
  return match ? match[1] : null;
};

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ req, query: rawQuery }) => {
  await authenticateUser(req.cookies, store.dispatch, store.getState());

  const { propertyid, ...query } = rawQuery;
  const propertyId = getPropertyId(propertyid);

  const sanitizedQuery = sanitizeProperty(query);
  const didSanitize = !isEqual(query, sanitizedQuery);

  if (didSanitize) {
    const newQueryString = queryString.stringify(sanitizedQuery);
    return {
      redirect: {
        permanent: false,
        destination: `/properties/${propertyid}/exclusive-offers?${newQueryString}`,
      },
    };
  }

  try {
    const { property } = await fetchPropertyDetails({ propertyId, cookie: req?.headers?.cookie });
    store.dispatch(fetchPropertySuccess({ property }));
  } catch (error) {
    return {
      notFound: true,
    };
  }

  try {
    const exclusiveOffer = await fetchExclusiveOffer({ propertyId, cookie: req?.headers?.cookie });
    store.dispatch(setExclusiveOffer(exclusiveOffer));
    store.dispatch(setExclusive(true));
  } catch (error) {
    // do nothing - assume exclusive offer is not available
  }

  return {
    props: {
      isExclusiveOffer: true,
    },
  };
});

export default Property;
